<mat-card class="cardWithShadow">
  <mat-card-content class="p-24">
    <div class="d-flex justify-content-between align-items-center m-b-16">
      <mat-card-title class="m-b-0">Active Bookings</mat-card-title>
      <span class="text-muted f-s-12">Last 30 days</span>
    </div>
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [colors]="chartOptions.colors"
      [dataLabels]="chartOptions.dataLabels"
      [stroke]="chartOptions.stroke"
      [fill]="chartOptions.fill"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [grid]="chartOptions.grid"
      [tooltip]="chartOptions.tooltip">
    </apx-chart>
  </mat-card-content>
</mat-card>
